module.exports = __webpack_public_path__ + "img/softwareag.651f1610.png";